// @flow

import React from 'react';
import Select from 'react-select';

// header

type Props = {
    results: { [key: string]: any },
    stayOpen: boolean,
    disabled: boolean,
    removeSelected: boolean,
    handleFilterChange: Function,
    rtl: boolean,
    values: string
};

const StatFilter = (props: Props) => {
    const options = [];
    if (props.results.playersLoading === false) {
        if (props.results.results.length > 0) {
            props.results.results.map(function(result) {
                if (options.some(x => x.value === result.stat) === false) {
                    return options.push({ value: result.stat, label: result.stat });
                }
                return null;
            });
        }
    }

    const display = (
        <div className={'select-stat'} style={{ paddingBottom: '10px' }}>
            <span>Statistic</span>
            <Select
                name="stat-filter"
                style={{ textAlign: 'left' }}
                closeOnSelect={!props.stayOpen}
                disabled={props.disabled}
                multi
                onChange={e => props.handleFilterChange(e, 'Stat')}
                options={options}
                placeholder="Select Statistic(s)"
                removeSelected={props.removeSelected}
                rtl={props.rtl}
                simpleValue
                value={props.values}
            />
        </div>
    );

    return display;
};

export default StatFilter;



// WEBPACK FOOTER //
// ./src/components/Main/Filters/StatFilter.js